export default class MessageHandler {

    static showFailMessage(formId, id, showModal = true) {
        let errorMessage = document.getElementById(id);
        if (!errorMessage) {
            const form = document.getElementById(formId);
            if (form) {
                errorMessage = form.querySelector(`[name="${id}"]`);
            }
        }
        const errorElements = document.querySelectorAll('.show--error');
        errorElements.forEach(el => el.classList.remove('show--error'));

        if (errorMessage) {
            errorMessage.parentElement.classList.add("show--error");
        }

        try {
            if (showModal) this.showErrorModal(id);
        } catch (error) {
            console.error("Error showing modal:", error);
        }
    }

    static showErrorModal(id) {
        const messageElement = document.getElementById(id);
        if (!messageElement) return;

        const message = messageElement.innerHTML;
        const modal = document.getElementById('error-message-forms');
        const modalDescription = modal ? modal.querySelector('.description') : null;

        if (modal && modalDescription) {
            modalDescription.innerHTML = message;
            modal.classList.add("open-modal");
        }
    }

    static removeAllFormFailMessages(selector = ".message-error-removed", elementClass = 'activate') {
        const inputGroups = document.querySelectorAll(selector);
        inputGroups.forEach(group => {
            group.classList.remove(elementClass);
        });

        const errorElements = document.querySelectorAll(".show--error");
        errorElements.forEach(el => el.classList.remove('show--error'));
    }
}
